import clsx from 'clsx'

const Divider = ({ className }) => (
  <div className={clsx('w-full', className, { 'h-0.5 my-4 bg-black/10': !className })} />
)

export default Divider
